import { IMAGE_PATHS } from 'constants/imagePaths';
import React, { useMemo, useEffect, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import useTranslate from 'hooks/useTranslate';
import { S3_URL } from 'constants/index';
import { unitNumber } from 'utils';
import useCompanyStore from 'store/company';
import { useCompanyDetailsMutation } from 'services';
import './styles.scss';
import { setModalConfig } from 'store/common';
import useAuthStore from 'store/auth';

const CompanyProfile: React.FC = () => {
	const { translate } = useTranslate();
	const { companyId }: any = useCompanyStore((state) => state);
	const { mutateAsync: companyProfile } = useCompanyDetailsMutation();
	const [userDetails, setUserDetails] = useState<any>({});
	const authUser: any = useAuthStore((state) => state.userInfo.user);

	useEffect(() => {
		if (companyId) {
			companyProfile(companyId)
				.then((res: any) => {
					setUserDetails(res);
				})
				.catch(() => {
					setUserDetails({});
				});
		} else {
			setUserDetails({});
		}
	}, [companyId]);

	const memoizedUserDetails = useMemo(() => userDetails, [userDetails]);
	const {
		userDetails: companyDetails = {},
		employees = 0,
		followers = 0,
		followings = 0,
	} = memoizedUserDetails;

	const handleClick = () => {
		if (!authUser?.userId) {
			setModalConfig({
				visible: true,
				type: 'loginModal',
			});
			return false;
		}
		return true;
	};

	return userDetails ? (
		<>
			<div>
				<div className="w-100 user-profile-bg">
					<Image
						src={
							companyDetails?.coverPicture
								? `${S3_URL}${companyDetails.coverPicture}`
								: IMAGE_PATHS.UserBG
						}
						alt="bg"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
				<div className="user-profile mx-auto">
					<Image
						src={
							companyDetails.profilePicture
								? `${S3_URL}${companyDetails.profilePicture}`
								: IMAGE_PATHS.UserDefault
						}
						alt="img"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
			</div>
			<div className="user-info">
				<h4 className="mb-1 fw-bold">{companyDetails?.companyName}</h4>
				<p className="mb-0">{companyDetails?.industryName}</p>
				{companyDetails?.companyFoundedYear ? (
					<p className="mb-0">
						{translate('Profile.foundedIn')} {companyDetails.companyFoundedYear}
					</p>
				) : (
					''
				)}
			</div>
			<div className="d-flex flex-wrap justify-content-center gap-2 guest-user-info">
				<p className="mb-0">
					<span>{unitNumber(followings, 0)}</span> {translate('Sidebar.followings')}
				</p>
				<p className="mb-0">•</p>
				<p className="mb-0">
					<span>{unitNumber(followers, 0)}</span> {translate('Common.connection')}
				</p>
				<p className="mb-0">
					<span>{unitNumber(employees, 0)}</span> {translate('Common.employees')}
				</p>
			</div>
			<div className="d-flex gap-3 guest-user-actions">
				<Button onClick={() => handleClick()} className="transparent-btn rounded-pill lh-1">
					{translate('Profile.viewProfile')}
				</Button>
				<Button onClick={() => handleClick()} className="filled-btn rounded-pill lh-1">
					{translate('Common.follow')}
				</Button>
			</div>
		</>
	) : (
		<></>
	);
};

export default CompanyProfile;
